import { combineReducers } from 'redux';
import authReducer from '../features/auth/authSlice';
import puzzlesReducer from '../features/puzzles/puzzlesSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  puzzles: puzzlesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;